import { Directive, HostListener, EventEmitter, Output } from '@angular/core';
import { DynamicRoute } from '../interfaces';
import { CommonService } from 'src/app/shared/services/common.service';
@Directive({
    selector: '[appDynamicNavigation]'
})
export class CardNavigationDirective {
    @Output() isNavClicked: EventEmitter<DynamicRoute> = new EventEmitter<DynamicRoute>();
    constructor(private _commonService: CommonService) {
    }
    @HostListener('click', ['$event', '$event.target'])
    onListenerTriggered($event: any, element: HTMLElement): void {
        // Prevent the default action of any element under static pages.
        $event.preventDefault();
        // Find the nearest ancestor anchor taf
        const linkElement: any = this.getClosest(element, 'A');
        if (linkElement && linkElement.attributes) {
            if (linkElement.attributes.href && linkElement.attributes.href.value) {
                const target = linkElement.attributes.target && linkElement.attributes.target.value;
                let routeUrl = this.addtionalParams(linkElement.attributes.href.value);;
                this.isNavClicked.emit({
                    route: routeUrl,
                    target: target || '_self'
                });
            }
        }
    }

    /**
    * @description find the selected parent element
    * using selector
    * @param {*} elem
    * @param {*} selector
    * @returns {HTMLElement}
    */
    getClosest(elem, selector): HTMLElement {
        for (; elem && elem !== document; elem = elem.parentNode) {
            if (elem.nodeName === selector) {
                return elem;
            }
        }
        return null;
    }
    /**
     * @description To add additional params
     * @author njagadeesan
     * @date 2020-01-20
     * @param {string} url
     * @returns {string}
     * @memberof CardNavigationDirective
     */
    addtionalParams(url: string): string {
        let isAppRoute = this._commonService.checkAppRoute(url);
        if (isAppRoute) {
            const isLegacy = this._commonService.legacyShopOrJoin(url);
            url = this._commonService.appendFBOID(url, isLegacy);
        }
        return url;
    }
}